import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IS_PRIVATE_API, IS_API_GATEWAY } from '@personal-area/global/http/models';

import { verificationProfileURLs } from '../constants/verification-profile';
import { VerificationProfileStatusResponse } from '../models/verification-profile-response';

@Injectable({ providedIn: 'root' })
export class VerificationProfileApiService {
  constructor(private _http: HttpClient) {}

  public closeBanner(userId: number): Observable<void> {
    return this._http.patch<void>(
      verificationProfileURLs.disableWidgetDisplay(userId),
      null,
      { context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true) },
    );
  }

  public getStatus(
    userId: number,
  ): Observable<VerificationProfileStatusResponse> {
    return this._http.get<VerificationProfileStatusResponse>(
      verificationProfileURLs.status(userId),
      {
        headers: {
          // Without it we would get strings instead of enums
          Accept: 'application/json',
        },
        context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
      },
    );
  }

  public setExpressVerification(userId: number): Observable<void> {
    return this._http.patch<void>(
      verificationProfileURLs.setExpressVerification(userId),
      null,
      { context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true) },
    );
  }
}
